import moment from 'moment-timezone';

/**
 * The 24-hour `HH:mm` string the visit forms store and parse (`parseTime` splits it on `:`).
 *
 * This is a VALUE, not display text, so it must not depend on the reader's locale:
 * `toLocaleTimeString` shapes it per locale (`fr-CA` → `14 h 05`, `da-DK` → `14.05`, `ar-EG` → Arabic
 * digits), and every one of those breaks the parse. Display goes through the locale-aware formatters.
 *
 * With a `timeZone` the wall-clock time is read in that zone; without one, in the device's zone.
 */
export const toTimeValue = (date: Date | string, timeZone?: string): string =>
  (timeZone ? moment.tz(date, timeZone) : moment(date)).format('HH:mm');
